import {Button} from 'antd'
import http from '@/biz/http.mjs'
import useAlert from '@/biz/useAlert.jsx'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function PropertiesPaneButtonExportReqConfirm(props) {
    const alert = useAlert()
    const map = useMapContext()
    const nodes = map.useSelectedNodes()

    if (1 !== nodes.size) {
        return null
    }

    const [node] = nodes
    const {bizNodeType, pkid: desId, prjId, sVer} = node.data

    if (
        ! desId ||
        'UC' !== bizNodeType
    ) {
        return null
    }

    const handleClick = async () => {
        await runAsync(
            () => http.post(
                '/prd/export/des/ucReqConfirmDoc',
                {desId, prjId, sVer}
            ),

            {action: '导出需求确认书'}
        )

        alert.generatingFile()
    }

    return (
        <Button
            onClick={handleClick}
            {...props}
        >
            导出需求确认书
        </Button>
    )
}
